/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import CenteredBriefBlogCard from "examples/Cards/BlogCards/CenteredBriefBlogCard";

import catalogChery from "data/catalog_chery";
import catalogDfsk from "data/catalog_dfsk";
import catalogJac from "data/catalog_jac";
import DefaultNavbarLayout from "layouts/defaultNavbar";
import Footer from "layouts/footer";

// Images
import bgImage from "assets/images/sucursal.png";

function Catalog({ brand }) {
  const brandName = brand ? brand.toLowerCase() : "";

  //obtener el listado de catalogo según brand
  //mostrar el catalogo
  //cada item debe llevar a brand/product/name

  let catalogData = "";
  if (brandName === "chery") {
    catalogData = catalogChery
  }
  else if (brandName === "dfsk") {
    catalogData = catalogDfsk
  }
  else if (brandName === "jac") {
    catalogData = catalogJac
  };
  
  const renderVehicleCards = catalogData.map((item) => (
    <Grid key={item.title} item xs={12} sm={6} lg={3}>
      <MKBox mb={6}>
        <CenteredBriefBlogCard
          image={item.image}
          action={{
            type: "internal",
            route: item.link,
            color: "info",
            label: item.title,
          }}
        />
      </MKBox>
    </Grid>
  ));

  return (
    <>
      <DefaultNavbarLayout />
      <MKBox bgColor="white">
        <MKBox
          minHeight="25rem"
          width="100%"
          sx={{
            backgroundImage: ({
              functions: { linearGradient, rgba },
              palette: { gradients },
            }) =>
              `${linearGradient(
                rgba(gradients.dark.main, 0.8),
                rgba(gradients.dark.state, 0.8)
              )}, url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "grid",
            placeItems: "center",
          }}
        />
        <Card
          sx={{
            p: 2,
            mx: { xs: 2, lg: 3 },
            mt: -8,
            mb: 4,
            backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
              rgba(white.main, 0.8),
            backdropFilter: "saturate(200%) blur(30px)",
            boxShadow: ({ boxShadows: { xxl } }) => xxl,
          }}
        >
          <MKBox component="section" py={{ xs: 6, sm: 12 }} >
            <Container>
              <Grid container item xs={12} justifyContent="center" textAlign="center">
                <MKTypography variant="h3" mb={8}>
                  Modelos
                </MKTypography>
              </Grid>

              <Grid container spacing={3}>
                {renderVehicleCards}
              </Grid>
            </Container>
          </MKBox>
        </Card>
        <Footer />
      </MKBox>
    </>
  );
}

export default Catalog;
